import React from 'react'
import CancelButton from './cancel-button'
import SubmitButton from './submit-button'

const CancelableSubmitButton = ({
  submitText,
  icon,
  cancelText,
  route,
  loading = false,
  disabled = false,
  testKey,
}) => {
  const submitClassName = 'btn btn--main-confirm'
  return (
    <div className='form-group btn--group'>
      <CancelButton
        text={cancelText}
        route={route}
        disabled={disabled}
        testKey={`${testKey}-cancel`}
      />
      <SubmitButton
        text={submitText}
        icon={icon}
        loading={loading}
        disabled={disabled}
        testKey={`${testKey}-submit`}
        className={submitClassName}
      />
    </div>
  )
}

export default CancelableSubmitButton
